/**
 * What the unread badge can show.
 *
 * Mirrors the LEAST(count(*), 99) in get_chat_unread_counts
 * (supabase/migrations/20260910140000_chat_unread_counts.sql): past this point the exact
 * number stops being information -- "a lot" is the whole message -- and counting further
 * would mean scanning the full history to render two characters.
 */
export const UNREAD_CAP = 99;

export function formatUnreadCount(count: number): string {
  if (count >= UNREAD_CAP) return `${UNREAD_CAP}+`;
  return String(count);
}
